import { Tooltip } from 'antd';
import { memo } from 'react';
import BlockIcon from '../../node-icon';
import { NodeEnum } from '../../types';
import { useBlocks } from './hooks';

type ListProps = {
  onSelect: (type: NodeEnum) => void;
  availableBlocksTypes?: NodeEnum[];
};
const List = ({ onSelect, availableBlocksTypes = [] }: ListProps) => {
  const blocks = useBlocks();

  const availableBlocks = blocks.filter((block) => {
    const blockType = block.type;
    return availableBlocksTypes.includes(blockType);
  });

  const isEmpty = blocks.length === 0;

  return (
    <>
      {!isEmpty && (
        <div className="w-full flex flex-col gap-1">
          {availableBlocks.map((block) => (
            <Tooltip
              key={block.type}
              // selector={`workflow-block-${block.type}`}
              // position="right"
              placement="right"
              // title={block.description}
              arrow={false}
            >
              <div
                className="w-full h-8 flex items-center rounded-lg hover:bg-gray-50 cursor-pointer"
                onClick={() => onSelect(block.type)}
              >
                <BlockIcon className="mr-2 shrink-0" type={block.type} />
                <div className="text-sm text-gray-900">{block.title}</div>
              </div>
            </Tooltip>
          ))}
        </div>
      )}
    </>
  );
};

export default memo(List);
